import { IDataSourceAttribute } from "@multiweb/reactCore/datasource";
import { LiteListFrameGeneralAttributeProps } from "UI/UI.React/frames/components";
import { IRenderer, IRendererRegistrator } from "../../types";

/**
 * Typ registrátoru pro LLFAttribute.
 */
export type ILLFAttributeRegistrator = ILLFAttributeRendererRegistrator<ILLFAttributeRenderer>;

/**
 * Interface LLFAttribute rendereru. Specifikuje metodu `canRender` a přidává metodu `getAttributes`,
 * která je specifická pro LLFAttribute.
 */
export interface ILLFAttributeRenderer extends IRenderer<LiteListFrameGeneralAttributeProps> {
    /** Metoda obrží surový html element reprezentující definici sloupce a je na ní, jestli se rozhodne že bude daný sloupec renderovat */
    canRender: (element: HTMLElement) => boolean;
    /** Získá dataSourceAttributes pro daný element. */
    getAttributes: (element: HTMLElement, ...args: any[]) => ReadonlyArray<IDataSourceAttribute>;
}
export class ILLFAttributeRenderer {
    private static _methods: (keyof ILLFAttributeRenderer)[] = ["canRender", "getAttributes"];
    private static _interfaces = [IRenderer];

    public static [Symbol.hasInstance](instance: any): boolean {
        return (
            instance != null &&
            this._methods.every((value) => typeof instance[value] === "function") &&
            this._interfaces.every((_interface) => instance instanceof _interface)
        );
    }
}
/**
 * Registrator pro LLF renderer atributů
 */
export interface ILLFAttributeRendererRegistrator<RendererType extends ILLFAttributeRenderer = any> extends IRendererRegistrator {
    /**
     * Zaregistruje renderer
     * @param priority Kladné nenulové číslo, které určuje prioritu pro výběr rendereru.
     * Čím vyšší číslo, tím vyšší priorita.
     * Číslo 0 je vyhrazeno defaultním rendererům, které poskytuje multiweb.
     */
    register(renderer: RendererType, priority?: number): void;
    /** Najde renderer pro daný element z DOMu. */
    findRenderer(element: HTMLElement): RendererType;
}
